import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { GinStyle, GinType } from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { GinProperties } from '@app/api/marketplace/models';

@Component({
  selector: 'app-gin-properties-subform',
  templateUrl: './gin-properties-subform.component.html',
  styleUrls: ['./gin-properties-subform.component.scss'],
})
export class GinPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.GIN_PROPERTIES';

  ginTypes = GinType;
  ginStyles = GinStyle;

  static buildForm(fb: FormBuilder, data?: GinProperties) {
    return fb.group({
      type: [data?.type, Validators.required],
      style: [data?.style, Validators.required],
    });
  }
}
